import type { UIMessage } from "ai";

/** Keep the last occurrence of each message id before POSTing to assistant APIs. */
export function dedupeUiMessagesForApiRequest(messages: UIMessage[]): UIMessage[] {
  const indexById = new Map<string, number>();
  messages.forEach((message, index) => {
    if (message.id) indexById.set(message.id, index);
  });
  if (indexById.size === messages.length) return messages;
  const keep = new Set(indexById.values());
  return messages.filter((_, index) => keep.has(index));
}
